import Model from "./Model";

class Conversation extends Model
{
    static Key = 'Conversation';

    static addMessageRecipients(message = {}, recipients = []) {
        let users = TB.filter(recipients, recipient => recipient.id !== message.sender?.id);
        return {
            ...message,
            recipients: TB.map(users, recipient => {
                return {
                    ...recipient,
                    has_viewed: !!recipient.last_viewed_at && TB.moment(message.sent_at).isSameOrBefore(recipient.last_viewed_at)
                }
            })
        }
    }
    static normalize(props)
    {
        props.messages = TB.orderBy(
            TB.map(
                props.messages || [], message => this.addMessageRecipients(message, props.recipients)
            ),
            message => TB.moment(message.sent_at).unix(), 'asc'
        )


        return props;
    }

    static async getConversation({queryKey, pageParam, signal}) {
        try {
            const [_key, { projectId, positionId, candidateId, page = pageParam || 1 }] = queryKey;
            let request;
            if(positionId) {
                request = TB.request(`/api/conversations/positions/${positionId}/candidates/${candidateId}`,{page});
            }else if(projectId && candidateId) {
                request = TB.request(`/api/conversations/projects/${projectId}/team-candidates/${candidateId}`,{page});
            }else if(candidateId) {
                request = TB.request(`/api/conversations/job-candidates/${candidateId}`,{page});
            }else {
                return null
            }
            let response = await request.get({signal}).catch(e => {
                console.warn('ERROR:getconvo ', e)
            });

            if (request.response.status === 404) {
                return null;
            }

            return this.make({...response.success.data.conversation});
        }catch (e) {
            throw new Error(e);
        }
    }
}


const getConversation = async(query) => {
    return Conversation.getConversation(query)
}

export default Conversation;
export {
    getConversation
}